module.exports = __webpack_public_path__ + "img/pic-3DVisual.b32867f9.jpg";